import history from 'history/browser'
import {
    CalculMaxEmpruntable,
    ControleTel,
    ControleTelEnvoyerCode,
    ControleTelWithValidationString,
    DitConnect,
    DitMessagePtz,
    DitParametresApporteurImmo,
    EnregistrerDossierRecherche,
    EnregistrerDossierTrouver,
    EstimerFraisNotaire,
    RechercheCommune,
    RecupereInfoContact,
    EnrTunnelTemp,
} from './ApiCommunicator'
import {
    scenarioDefault,
    scenarioRecherche,
    scenarioRenego,
    scenarioTrouver,
} from './ScenarioDeTest'
import store from './store'
import * as constants from './constants'

/*
    Regroupe Ici les différentes fonction de traitement/transformation/calcul de données
*/

/**
 * Fonction permettant de sauter les champs déjà pré-remplis
 * @param {boolean} uniquement_neuf
 */
const sauterChampsPreremplis = (uniquement_neuf = false) => {
    // Ne faire de transition que si l'on vient d'une page
    // de chargement,
    // Ceci est fait pour éviter d'écraser les changement de view qui sont effectués en mode debug ou
    // en mode origine partenaire/bo/wai
    // La vue 27 == Vue de chargement, voir le fichier StepDefinition.js
    if (
        store.getState().view === 27 &&
        store.getState().answer.tech_debug_mode !== true
    ) {
        history.push('/tunnelmobile/', {
            targetView: uniquement_neuf ? 1 : 0,
        })

        const maturite = store.getState().answer.prj_maturite
        const type_projet = store.getState().answer.prj_type
        const usage = store.getState().answer.prj_usage

        if (maturite !== undefined && maturite !== null) {
            history.push('/tunnelmobile/', {
                targetView: 2,
            })

            if (type_projet !== undefined && type_projet !== null) {
                history.push('/tunnelmobile/', {
                    targetView: 3,
                })

                if (usage !== undefined && usage !== null) {
                    history.push('/tunnelmobile/', {
                        targetView: 4,
                    })
                }
            }
        }
    }
}

/**
 * Calcul un age a partir d'une dateString (récupérée lors de la saisie des date de naissances)
 * par défaut calcule la différence avec Date.now(),
 * Si une date particulière est passée en paramètre, on l'utilise a la place pour calculer la différence
 */
const calculeAgeFromDateString = (dateString, dateAComparer) => {
    if (dateString && dateString !== '') {
        var parts = dateString.split('/')
        const date = new Date(parts[2], parts[1] - 1, parts[0])
        var diff = 0
        if (dateAComparer) {
            diff = dateAComparer.getTime() - date.getTime()
        } else {
            diff = Date.now() - date.getTime()
        }
        var age = new Date(diff)
        return Math.abs(age.getUTCFullYear() - 1970)
    }
}

/*
    Calcul les frais de notaire en fonction d'un type de projet et des valeurs associé 
    8% de frais pour de l'ancien
    3% de frais pour du neuf
    dans le cas d'une construction avec terrain : terrain ancien a 3% et construction neuve a 8%
*/
const CalculFraisDeNotaire = (prixAchat, prixTerrain, projetType, rounded) => {
    let prix = 0
    if (projetType === 'TERRAIN_ET_CONSTRUCTION' && prixTerrain) {
        prix = prixTerrain
    } else if (projetType !== 'TERRAIN_ET_CONSTRUCTION' && prixAchat) {
        prix = prixAchat
    }

    EstimerFraisNotaire(prix, projetType, 'frais_de_notaire')
}

/*
    initialize le listener de l'historique de navigation
    a chaque changement de l'objet "history" -> mets a jours la view associé
*/
const InitHistoryListener = () => {
    history.listen(({ location, action }) => {
        if (
            location.state !== undefined &&
            location.state !== null &&
            location.state.targetView !== undefined &&
            location.state.targetView !== null
        ) {
            store.dispatch({
                type: 'SET_VIEW',
                value: location.state.targetView,
            })
        } else {
            console.log(JSON.stringify(location.state))
        }
    })

    if (
        history.location !== undefined &&
        history.location.search !== undefined
    ) {
        var view = getParameterByNameOnUrl('view')
        if (view !== '' && view !== null) {
            history.replace('/tunnelmobile/', { targetView: view })
        } else {
            history.push('/tunnelmobile/', { targetView: 0 })
        }
    } else {
        history.push('/tunnelmobile/', { targetView: 0 })
    }
}

/*
    calcul le nombre de document actuellement pret (préenvoyés) pour la demande de comparaison d'offre
*/
const CalculNbDocumentPretPourComparerOffre = (files) => {
    var NbDocument = 0
    files.forEach((file) => {
        if (file.uuid !== '') {
            NbDocument += 1
        }
    })
    store.dispatch({
        type: 'SET',
        value: {
            key: 'tech_nb_document_pour_comparer_offre',
            value: NbDocument,
        },
    })
    return NbDocument
}

/*
    calcul le poid total des fichiers ( préenvoyés et non préenvoyés) en octet
*/
const CalculPoidTotalDocPourComparerOffre = (files) => {
    var TotalPoid = 0
    files.forEach((file) => {
        if (file.size) {
            TotalPoid += file.size
        }
    })
    return TotalPoid
}

/*
    convertie un int en string délimité
*/
const IntToSpacedDelimitedString = (valueInt, delimiter) => {
    return valueInt
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + delimiter)
}

const UpdateIntField = (key, value, limit) => {
    if (
        value.floatValue !== undefined &&
        value.floatValue !== null &&
        !isNaN(value.floatValue)
    ) {
        var valueToSave = Math.round(value.floatValue)
        if (limit !== undefined && valueToSave > limit) {
            store.dispatch({ type: 'SET', value: { key: key, value: limit } })
            store.dispatch({
                type: 'SET',
                value: { key: key + '_validated', value: false },
            })
            valueToSave = limit
        } else {
            store.dispatch({
                type: 'SET',
                value: { key: key, value: valueToSave },
            })
            store.dispatch({
                type: 'SET',
                value: { key: key + '_validated', value: true },
            })
        }
    } else {
        store.dispatch({ type: 'REMOVE', value: { key: key } })
    }
}
/*
    convertie un int en string délimité
*/
const PaliersObjectToCapitalDuree = (paliers) => {
    var capital = 0
    var duree = 0
    var mensualite = 0
    if (paliers !== undefined) {
        paliers.map((palier) => {
            duree += palier.duree
            capital += palier.mensualite * palier.duree
            return []
        })

        if (duree > 0) {
            mensualite = Math.round(capital / duree)
        }
    }

    return {
        capital: capital,
        duree: duree,
        mensualite: mensualite,
    }
}

/*
    test value with regex and determine if the key is valid
*/
const TestRegexForField = (key, valueToTest, regex) => {
    if (regex.test(valueToTest)) {
        store.dispatch({
            type: 'SET',
            value: { key: key + '_validated', value: true },
        })
        return true
    } else {
        store.dispatch({
            type: 'SET',
            value: { key: key + '_validated', value: false },
        })
        return false
    }
}
/**
 * Renvoi si l'utilisateur est sur un navigateur mobile ou non
 **/
const isMobileDevice = () => {
    var check = false
    ;(function (a) {
        if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                a
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                a.substr(0, 4)
            )
        )
            check = true
    })(navigator.userAgent || navigator.vendor || window.opera)
    return check
}

const getParameterByNameOnUrl = (name, url) => {
    // Utilisation de l'objet searchParams directement pour récupérer la valeur d'un paramètre sur l'URL
    const searchParams = new URL(
        url ?? window.location.href,
        window.location.origin
    ).searchParams

    return searchParams.get(name)
}
/*
    Initialise le Dossier
    exemple d'url de test : http://monemprunt.local/tunnelmobile/?cle=20180125-ABCDEF&usage=RES_PRINCIPALE&apport=14070&primo_accedant=1&immeuble=LOGEMENT_ANCIEN_PTZ&nb_occupant=2&revenu_fiscal=50000&cc=35238&cp=&prix_logement=140700&loyer=0&duree_pp=216&entite_code=unCode&campagne=uneCampagne
*/
const ModeDebug = (scenario) => {
    switch (scenario) {
        case 'trouver':
            store.dispatch({
                type: 'OVERWRITE_ALL_ANSWER',
                value: scenarioTrouver,
            })
            break
        case 'recherche':
            store.dispatch({
                type: 'OVERWRITE_ALL_ANSWER',
                value: scenarioRecherche,
            })
            break
        case 'renego':
            store.dispatch({
                type: 'OVERWRITE_ALL_ANSWER',
                value: scenarioRenego,
            })
            break
        default:
            store.dispatch({
                type: 'OVERWRITE_ALL_ANSWER',
                value: scenarioDefault,
            })
            break
    }
    store.dispatch({
        type: 'SET',
        value: { key: 'tech_debug_mode', value: true },
    })
}

/**
 * fonction pour vérifier si l'hôte actuel est une marque blanche
 */
function isHostMarqueBlanche() {
    return constants.MARQUES_BLANCHES.some(
        ({ url_prefix }) => window.location.hostname.match(url_prefix) !== null
    )
}

/*
    Initialise le Dossier
    exemple d'url de test : http://monemprunt.local/tunnelmobile/?cle=20180125-ABCDEF&usage=RES_PRINCIPALE&apport=14070&primo_accedant=1&immeuble=LOGEMENT_ANCIEN_PTZ&nb_occupant=2&revenu_fiscal=50000&cc=35238&cp=&prix_logement=140700&loyer=0&duree_pp=216&entite_code=unCode&campagne=uneCampagne
*/

const InitDossier = () => {
    const cle = getParameterByNameOnUrl('cle') // CLE WAI pour identifier
    const apporteur_code = getParameterByNameOnUrl('apcode') // utilisé par des URL personnalisé d'utilisateur de partenaire immo

    let chargerParamsPartenaires =
        cle !== null || apporteur_code !== null || isHostMarqueBlanche()

    if (getParameterByNameOnUrl('debug')) {
        ModeDebug(getParameterByNameOnUrl('scenario'))
    } else {
        if (!getParameterByNameOnUrl('view') && chargerParamsPartenaires) {
            // Afficher La vue de chargement au début, vu que l'on fait une requête à l'API
            // pour connaitre les infos du partenaire
            store.dispatch({
                type: 'SET_VIEW',
                value: 27, // La vue 27 == Vue de chargement, voir le fichier StepDefinition.js
            })
        }
    }

    store.dispatch({
        type: 'SET',
        value: { key: 'tech_already_initialized', value: 'STARTED' },
    })

    DitConnect(0)
    DitMessagePtz(0)

    if (chargerParamsPartenaires) {
        DitParametresApporteurImmo()
    }

    if (isMobileDevice()) {
        store.dispatch({
            type: 'SET',
            value: { key: 'tech_device_size', value: 'MOBILE' },
        })
    } else {
        store.dispatch({
            type: 'SET',
            value: { key: 'tech_device_size', value: 'DESKTOP' },
        })
    }

    /* RECUPERATION D'ELEMENT TECHNIQUE */
    const cleRattachement = getParameterByNameOnUrl('cle_rattachement') // CLE De rattachement pour identifier l'entité juridique
    const entite_code = getParameterByNameOnUrl('entite_code') //code de l'entité structurel du partenaire immo
    const ext_id = getParameterByNameOnUrl('ext_id') // utilisé par des URL personnalisé d'utilisateur de partenaire immo
    const ref_part = getParameterByNameOnUrl('ref_part') // utilisé par des URL personnalisé d'utilisateur de partenaire immo
    const campagne = getParameterByNameOnUrl('campagne') // nom de campagne, enregistré dans BDD
    const campagne_google = getParameterByNameOnUrl('campaign') // nom de campagne google, enregistré dans BDD
    const campagne_facebook = getParameterByNameOnUrl('utm_campaign') // nom de campagne, enregistré dans BDD
    const campagne_youtube = getParameterByNameOnUrl('utm_youtube') // nom de campagne, enregistré dans BDD
    const source_facebook = getParameterByNameOnUrl('utm_source') // nom de campagne, enregistré dans BDD
    const demande_hors_france = getParameterByNameOnUrl('demande_hors_france') // nom de campagne, enregistré dans BDD
    const esquive_sms = getParameterByNameOnUrl('esquive_sms') // si 'true', esquive la vérification SMS
    const contact = getParameterByNameOnUrl('contact') // id d'un contact a chargé (ex : 7643a919-2e57-4f78-86ed-0e0442c8a9b1)
    const cacher_header = getParameterByNameOnUrl('hide_header') // S'il faut cacher le header
    const id_utilisateur_cible = getParameterByNameOnUrl('id_utilisateur_cible') // ID de l'utilisateur partenaire a qui affecter le dossier
    if (cacher_header === 'true') {
        store.dispatch({
            type: 'SET',
            value: {
                key: 'cacher_header',
                value: true,
            },
        })
    }

    if (!cle && !apporteur_code) {
        // Propager la clé en cas de minisite
        for (const minisite of constants.MARQUES_BLANCHES) {
            if (window.location.hostname.match(minisite.url_prefix)) {
                store.dispatch({
                    type: 'SET',
                    value: { key: 'source_cle', value: minisite.cle },
                })
                break
            }
        }
    }

    if (cle) {
        store.dispatch({
            type: 'SET',
            value: { key: 'source_cle', value: cle },
        })

        // cas particulier Lamotte maison individuel (existe a 2 endroits : ici et dans apicom avec check partenaire suite apcode)
        if (cle === '210707-DCQ4CH') {
            store.dispatch({
                type: 'SET',
                value: { key: 'tech_type_action_depart', value: 'estimer' },
            })
            store.dispatch({
                type: 'SET',
                value: { key: 'tech_esquiver_prj_type', value: true },
            })
            store.dispatch({
                type: 'SET',
                value: { key: 'prj_type', value: 'TERRAIN_ET_CONSTRUCTION' },
            })
        }
        if (id_utilisateur_cible) {
            store.dispatch({
                type: 'SET',
                value: {
                    key: 'source_id_utilisateur_cible',
                    value: id_utilisateur_cible,
                },
            })
        }
    }

    if (cleRattachement) {
        store.dispatch({
            type: 'SET',
            value: { key: 'source_cle_rattachement', value: cleRattachement },
        })
    }
    if (entite_code) {
        store.dispatch({
            type: 'SET',
            value: { key: 'source_entite_code', value: entite_code },
        })
    }
    if (ext_id) {
        store.dispatch({
            type: 'SET',
            value: { key: 'source_ext_id', value: ext_id },
        })
    }
    if (ref_part) {
        store.dispatch({
            type: 'SET',
            value: { key: 'source_ext_id', value: ref_part },
        })
    }
    if (campagne) {
        store.dispatch({
            type: 'SET',
            value: { key: 'source_campagne', value: campagne },
        })
    }
    const campagne_utm = !!campagne_google
        ? 'GOOGLE_' + campagne_google
        : !!campagne_facebook
        ? 'FB_' + source_facebook + '_' + campagne_facebook
        : !!campagne_youtube
        ? 'YOUTUBE_' + campagne_youtube
        : null

    if (campagne_utm) {
        store.dispatch({
            type: 'SET',
            value: { key: 'source_campagne_utm', value: campagne_utm },
        })
    }

    const origine = getParameterByNameOnUrl('origine') // origine d'arrivée sur le tunnel

    /**
     * Creation d'un dossier a partir d'une fiche contact
     */
    if (!!contact) {
        store.dispatch({ type: 'SET_VIEW', value: 1 })

        store.dispatch({
            type: 'SET',
            value: { key: 'tech_contact_id', value: contact },
        })
        store.dispatch({
            type: 'SET',
            value: { key: 'tech_contact_status', value: 'LOAD' },
        })
        RecupereInfoContact(0, contact)
    }

    if (origine === 'wai-direct') {
        store.dispatch({
            type: 'SET',
            value: {
                key: 'source_origin_creation',
                value: constants.ORIGIN_WAI_DIRECT,
            },
        })
        store.dispatch({
            type: 'SET',
            value: { key: 'tech_type_action_depart', value: 'estimer' },
        })
        store.dispatch({
            type: 'SET',
            value: { key: 'prj_maturite', value: 'TROUVE' },
        })
        store.dispatch({ type: 'SET_VIEW', value: 2 })
    } else if (origine === 'wai-calculette') {
        store.dispatch({
            type: 'SET',
            value: {
                key: 'source_origin_creation',
                value: constants.ORIGIN_WAI_CALCULETTE,
            },
        })
        store.dispatch({
            type: 'SET',
            value: { key: 'tech_type_action_depart', value: 'estimer' },
        })
        store.dispatch({ type: 'SET_VIEW', value: 1 })
    } else if (origine === 'bo-courtier') {
        /**
         * Arrivé depuis le BO Courtier.
         */
        if (!!contact) {
            store.dispatch({
                type: 'SET',
                value: {
                    key: 'source_origin_creation',
                    value: constants.ORIGIN_COURTIER_DEPUIS_CONTACT,
                },
            })
        } else {
            /**
             * Création d'un nouveau dossier vierge
             */
            store.dispatch({
                type: 'SET',
                value: {
                    key: 'source_origin_creation',
                    value: constants.ORIGIN_COURTIER_NEW,
                },
            })
            store.dispatch({ type: 'SET_VIEW', value: 1 })
        }
    } else if (origine === 'bo-partenaire' && !!apporteur_code) {
        /**
         * Cas depuis nouveau BO, l'origine est défini,en tant que Bo-partenaire, et apporteur code défini aussi
         */
        store.dispatch({
            type: 'SET',
            value: {
                key: 'source_origin_creation',
                value: constants.ORIGIN_PARTENAIRE_NEW_BO_PART_V2,
            },
        })
        store.dispatch({
            type: 'SET',
            value: { key: 'tech_type_action_depart', value: 'estimer' },
        })
        store.dispatch({ type: 'SET_VIEW', value: 1 })
        store.dispatch({
            type: 'SET',
            value: {
                key: 'source_apporteur_code',
                value: apporteur_code,
            },
        })
    } else if (origine === 'bo-partenaire') {
        /**
         * Arrivé depuis le BO partenaire dans le cas ou c'est un partenaire IOBSP
         * La method ditConnect retourne l'utilisateur actuelle et est sensé etre un utilisateur immo.
         */
        store.dispatch({
            type: 'SET',
            value: {
                key: 'source_origin_creation',
                value: constants.ORIGIN_PARTENAIRE_NEW,
            },
        })
        store.dispatch({
            type: 'SET',
            value: { key: 'tech_type_action_depart', value: 'estimer' },
        })
        store.dispatch({ type: 'SET_VIEW', value: 1 })
    } else if (!!apporteur_code) {
        store.dispatch({
            type: 'SET',
            value: {
                key: 'source_origin_creation',
                value: constants.ORIGIN_PARTENAIRE_LIEN_TUNNEL,
            },
        })
        store.dispatch({
            type: 'SET',
            value: { key: 'source_apporteur_code', value: apporteur_code },
        })
    } else if (!!campagne_google) {
        store.dispatch({
            type: 'SET',
            value: {
                key: 'source_origin_creation',
                value: constants.ORIGIN_PUB_GOOGLE,
            },
        })
    } else if (!!campagne_facebook) {
        store.dispatch({
            type: 'SET',
            value: {
                key: 'source_origin_creation',
                value: constants.ORIGIN_PUB_FACEBOOK,
            },
        })
    } else if (!!campagne_youtube) {
        store.dispatch({
            type: 'SET',
            value: {
                key: 'source_origin_creation',
                value: constants.ORIGIN_PUB_YOUTUBE,
            },
        })
    } else if (!!origine) {
        store.dispatch({
            type: 'SET',
            value: { key: 'source_origin_creation', value: origine },
        })
    } else {
        // si le contact est defini
        if (!!contact) {
            /**
             * Création d'un dossier a partir d'une fiche contact associée à un client.
             * Nous sommes obligés de subscribe car au vu du fonctionnement de redux,
             * on ne peut pas recuperer les donnees du store directement.
             *
             * Donc on subscribe au store pour recuperer l'user au cas il est set et
             * mettre a jour l'origine en consequence.
             */
            const unsubscribe = store.subscribe(() => {
                // On se desabonne du store car on en a plus besoin
                if (store.getState().answer.user_id === undefined) unsubscribe()

                if (store.getState().answer.user_id !== -1) {
                    // l'user n'est pas connecté
                    store.dispatch({
                        type: 'SET',
                        value: {
                            key: 'source_origin_creation',
                            value: constants.ORIGIN_CLIENT_DEPUIS_CONTACT,
                        },
                    })
                } else {
                    // l'user est connecté
                    store.dispatch({
                        type: 'SET',
                        value: {
                            key: 'source_origin_creation',
                            value: constants.ORIGIN_CLIENT_DEPUIS_MAIL,
                        },
                    })
                }
            })
        }
    }

    if (demande_hors_france && demande_hors_france === 'true') {
        store.dispatch({
            type: 'SET',
            value: { key: 'source_demande_hors_france', value: true },
        })
    }

    if (esquive_sms && esquive_sms === 'true') {
        store.dispatch({
            type: 'SET',
            value: { key: 'source_esquive_sms', value: true },
        })
    }
    /* RECUPERATION D'ELEMENT METIER LIE AU PROJET ET REMPLISSAGE DES CHAMPS CORRESPONDANTS  */
    const nom = getParameterByNameOnUrl('nom')
    const prenom = getParameterByNameOnUrl('prenom')
    let tel = getParameterByNameOnUrl('tel')
    const mail = getParameterByNameOnUrl('mail')
    const apport = getParameterByNameOnUrl('apport')
    const cc = getParameterByNameOnUrl('cc')
    const cp = getParameterByNameOnUrl('cp')
    const dispositif_fiscal = getParameterByNameOnUrl('dispositif_fiscal')
    const duree_pp = getParameterByNameOnUrl('duree_pp')
    const immeuble = getParameterByNameOnUrl('immeuble')
    const loyer = getParameterByNameOnUrl('loyer')
    const maturite = getParameterByNameOnUrl('maturite')
    const nb_occupant = getParameterByNameOnUrl('nb_occupant')
    const primo_accedant = getParameterByNameOnUrl('primo_accedant')
    const prix_logement = getParameterByNameOnUrl('prix_logement')
    const revenu_fiscal = getParameterByNameOnUrl('revenu_fiscal')
    const type = getParameterByNameOnUrl('type')
    const usage = getParameterByNameOnUrl('usage')
    const profil = getParameterByNameOnUrl('profil')

    // Listes blanches des paramètres projet reçus par URL : ces valeurs sont ensuite persistées
    // en base côté back (colonnes contraintes par FK) ; une valeur hors liste doit être ignorée
    // ici plutôt que de remonter jusqu'au dépôt du dossier en fin de tunnel.
    const PRJ_USAGE_VALIDES = ['RES_PRINCIPALE', 'RES_SECONDAIRE', 'LOCATIF', 'PRO']
    const PRJ_TYPE_PTZ_VALIDES = [
        'LOGEMENT_NEUF',
        'LOGEMENT_ANCIEN_PTZ',
        'LOGEMENT_ANCIEN_NON_PTZ',
        'RACHAT_LOGEMENT_SOCIAL',
    ]
    const PRJ_TYPE_VALIDES = [
        'LOGEMENT_NEUF',
        'LOGEMENT_ANCIEN',
        'TERRAIN',
        'CONSTRUCTION',
        'TERRAIN_ET_CONSTRUCTION',
        'TRAVAUX',
        'RENEGOCIATION',
        'ACHAT_SCPI',
    ]
    const PRJ_MATURITE_VALIDES = ['SIGNE', 'TROUVE', 'RECHERCHE']
    const PRJ_DISPOSITIF_FISCAL_VALIDES = [
        'PINEL_6',
        'PINEL_9',
        'PINEL_12',
        'LMNP',
        'LMNP_S',
        'LMNP_CB',
        'LMNP_CB_S',
        'AUTRE',
        'SCPI_PINEL_6',
        'SCPI_PINEL_9',
        'SCPI_PINEL_12',
        'SCPI_RENDEMENT',
        'SCPI_AUTRE',
    ]

    if (nom) {
        store.dispatch({
            type: 'SET',
            value: { key: 'contact_nom', value: nom },
        })
    }
    if (prenom) {
        store.dispatch({
            type: 'SET',
            value: { key: 'contact_prenom', value: prenom },
        })
    }

    if (tel) {
        TestRegexForField('contact_mobile', tel, /^(0|(00|\+)33)[67][0-9]{8}$/)
        if (tel.startsWith('0')) {
            tel = '+33' + tel.substring(1, tel.length)
        }
        store.dispatch({
            type: 'SET',
            value: { key: 'contact_mobile', value: tel },
        })
    }
    if (mail) {
        TestRegexForField(
            'contact_mail',
            mail,
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
        store.dispatch({
            type: 'SET',
            value: { key: 'contact_mail', value: mail },
        })
    }

    if (usage) {
        if (PRJ_USAGE_VALIDES.includes(usage)) {
            store.dispatch({
                type: 'SET',
                value: { key: 'prj_usage', value: usage },
            })
        } else {
            console.warn(`Paramètre URL 'usage' ignoré (valeur inattendue) : ${usage}`)
        }
    }
    if (apport) {
        store.dispatch({
            type: 'SET',
            value: { key: 'finance_apport', value: parseInt(apport, 10) },
        })
    }
    if (immeuble) {
        if (PRJ_TYPE_PTZ_VALIDES.includes(immeuble)) {
            store.dispatch({
                type: 'SET',
                value: { key: 'prj_type_ptz', value: immeuble },
            })
            if (immeuble === 'LOGEMENT_NEUF') {
                store.dispatch({
                    type: 'SET',
                    value: { key: 'prj_type', value: 'LOGEMENT_NEUF' },
                })
            } else {
                store.dispatch({
                    type: 'SET',
                    value: { key: 'prj_type', value: 'LOGEMENT_ANCIEN' },
                })
            }
        } else {
            console.warn(`Paramètre URL 'immeuble' ignoré (valeur inattendue) : ${immeuble}`)
        }
    }
    if (type) {
        if (PRJ_TYPE_VALIDES.includes(type)) {
            store.dispatch({ type: 'SET', value: { key: 'prj_type', value: type } })
        } else {
            console.warn(`Paramètre URL 'type' ignoré (valeur inattendue) : ${type}`)
        }
    }

    if (maturite) {
        if (PRJ_MATURITE_VALIDES.includes(maturite)) {
            store.dispatch({
                type: 'SET',
                value: { key: 'prj_maturite', value: maturite },
            })
        } else {
            console.warn(`Paramètre URL 'maturite' ignoré (valeur inattendue) : ${maturite}`)
        }
    }
    if (dispositif_fiscal) {
        if (PRJ_DISPOSITIF_FISCAL_VALIDES.includes(dispositif_fiscal)) {
            store.dispatch({
                type: 'SET',
                value: { key: 'prj_dispositif_fiscal', value: dispositif_fiscal },
            })
        } else {
            console.warn(`Paramètre URL 'dispositif_fiscal' ignoré (valeur inattendue) : ${dispositif_fiscal}`)
        }
    }
    if (prix_logement) {
        store.dispatch({
            type: 'SET',
            value: {
                key: 'prj_montant_achat',
                value: parseInt(prix_logement, 10),
            },
        })
    }
    if (duree_pp) {
        var duree = Math.round(parseInt(duree_pp, 10) / 12 / 5) * 5
        if (duree < 10) {
            duree = 10
        }
        if (duree > 30) {
            duree = 30
        }
        store.dispatch({
            type: 'SET',
            value: { key: 'finance_duree_souhaite', value: duree },
        })
    }
    if (cc) {
        RechercheCommune(cc, 1, 'prj_localisation_ville')
    } else if (cp) {
        RechercheCommune(cp, 1, 'prj_localisation_ville')
    }

    if (usage && usage === 'LOCATIF' && loyer) {
        store.dispatch({
            type: 'SET',
            value: { key: 'prj_futur_loyer_estim', value: parseInt(loyer, 10) },
        })
    }
    if (usage && usage === 'RES_PRINCIPALE') {
        if (primo_accedant === 1) {
            store.dispatch({
                type: 'SET',
                value: { key: 'emp_proprio_last_2_ans', value: 'NON' },
            })
        }
        if (nb_occupant) {
            store.dispatch({
                type: 'SET',
                value: {
                    key: 'emp_nb_personnes_foyer',
                    value: parseInt(nb_occupant, 10),
                },
            })
        }
        if (revenu_fiscal) {
            store.dispatch({
                type: 'SET',
                value: {
                    key: 'finance_revenu_fiscal_ref',
                    value: parseInt(revenu_fiscal, 10),
                },
            })
        }
    }

    if (profil && profil.toUpperCase() === 'RECHERCHE') {
        store.dispatch({
            type: 'SET',
            value: { key: 'tech_type_action_depart', value: 'estimer' },
        })
        store.dispatch({
            type: 'SET',
            value: { key: 'prj_maturite', value: 'RECHERCHE' },
        })
        store.dispatch({ type: 'SET_VIEW', value: 2 })
    } else if (profil && profil.toUpperCase() === 'TROUVER') {
        store.dispatch({
            type: 'SET',
            value: { key: 'tech_type_action_depart', value: 'estimer' },
        })
        store.dispatch({
            type: 'SET',
            value: { key: 'prj_maturite', value: 'TROUVE' },
        })
        store.dispatch({ type: 'SET_VIEW', value: 2 })
    }

    store.dispatch({
        type: 'SET',
        value: { key: 'tech_already_initialized', value: 'ENDED' },
    })
}

/*
   Rêgle de gestion des envoi de dossier 
   appeler a la fin du formulaire pour les dossier en recherche ou trouver, prend en change la vérification de numéro mobile
*/
const EnregistrerDossier = (answer) => {
    var functionAPiCall

    if (answer.prj_type === 'RENEGOCIATION') {
        store.dispatch({
            type: 'SET',
            value: { key: 'prj_maturite', value: 'TROUVE' },
        })
        answer.prj_maturite = 'TROUVE'
    }

    if (answer.prj_maturite === 'RECHERCHE') {
        functionAPiCall = function () {
            if (answer.tech_enr_dossier_status === 'SEND') {
                history.push('/tunnelmobile/', { targetView: 21 })
            } else {
                history.push('/tunnelmobile/', { targetView: 21 })

                EnregistrerDossierRecherche(
                    ConstructionJsonEnrDossierRecherche(answer),
                    answer.tech_token_csrf
                )
            }
            CalculMaxEmpruntable(
                ConstructionJsonEnrDossierRecherche(answer),
                answer.tech_token_csrf
            )
        }
    } else if (answer.prj_maturite === 'TROUVE') {
        functionAPiCall = function () {
            history.push('/tunnelmobile/', { targetView: 21 })

            EnregistrerDossierTrouver(
                ConstructionJsonEnrDossierTrouve(answer),
                answer.tech_token_csrf
            )
        }
    }

    // si le numéro n'est pas validé alors on demande un controle
    // on passe en paramètre la fonction final que l'on vise, car si aucune validation est necessaire on l'execute direct
    if (answer.tech_part_est_cgp === true) {
        functionAPiCall()
    } else if (answer.tech_part_esquive_sms === true) {
        functionAPiCall()
    } else if (
        answer.contact_mobile &&
        answer.contact_mobile.startsWith('+1')
    ) {
        // esquive SMS pour les numéros nord-américains (indicatif +1)
        functionAPiCall()
    } else if (answer.source_esquive_sms === true) {
        functionAPiCall()
    } else if (answer.source_demande_hors_france === true) {
        functionAPiCall()
    } else if (answer.tech_mobile_num_a_valider === true) {
        history.push('/tunnelmobile/', { targetView: 24 })
        ControleTelWithValidationString(
            answer.tech_token_csrf,
            answer.tech_mobile_code_sms,
            answer.tech_mobile_client_id,
            answer.contact_mobile,
            functionAPiCall
        )
    } else {
        EnrTunnelTemp(ConstructionTunnelTemp(answer), answer.tech_token_csrf)
        store.dispatch({
            type: 'SET',
            value: { key: 'tech_mobile_num_a_valider', value: false },
        })
        history.push('/tunnelmobile/', { targetView: 24 })
        ControleTel(
            0,
            answer.tech_token_csrf,
            answer.contact_mail,
            answer.contact_mobile,
            functionAPiCall
        )
    }
}

/*
   Envoyer un nouveau sms 
*/
const relanceCodeSms = (answer) => {
    if (answer.tech_mobile_relance_code_ok === true) {
        ControleTelEnvoyerCode(
            0,
            answer.tech_token_csrf,
            answer.tech_mobile_client_id,
            answer.contact_mobile
        )
    }
}

/*
   Rêgle de gestion des envoi de dossier 
   appeler a la fin du formulaire pour les dossier en recherche ou trouver, prend en change la vérification de numéro mobile
*/
const ActualisationResultatMaxEmpruntable = (answer) => {
    CalculMaxEmpruntable(
        ConstructionJsonEnrDossierRecherche(answer),
        answer.tech_token_csrf
    )
}

/*
   Euros vers centime 
*/
const ConvertionEuroCentime = (value) => {
    var newValue = value * 100
    return newValue
}

/*
    Tableau des organisme solicité
*/
const ConstructionObjetOrganismeSolicite = (answer) => {
    var organismeSolicite = []
    if (answer.tech_solicitation) {
        switch (answer.tech_solicitation) {
            case 'personne':
                break
            case 'mabanque':
                organismeSolicite.push(answer.autres_contacts_banque_solicite_1)
                break
            case 'plusieursbanques':
                organismeSolicite = answer.autres_contacts_banque_solicite_2
                    ? answer.autres_contacts_banque_solicite_2
                    : []
                break
            case 'courtiers':
                organismeSolicite.push(answer.autres_contacts_courtier_solicite)
                break
            default:
                break
        }
    }
    return organismeSolicite
}

/*
    Tableau les prêt en cours 
*/
const ConstructionObjetPretARenegocier = (answer) => {
    var pretARenegoier = []
    if (answer.credit_renego_list) {
        pretARenegoier = answer.credit_renego_list.map((pretID) => {
            var pret = {
                type: answer['credit_renego_type_' + pretID]
                    ? answer['credit_renego_type_' + pretID]
                    : 'pret_bancaire',
                preteur: answer['credit_renego_preteur_' + pretID]
                    ? answer['credit_renego_preteur_' + pretID]
                    : 'inconnu',
                'capital-restant': answer['credit_renego_capital_' + pretID]
                    ? answer['credit_renego_capital_' + pretID] * 100
                    : 0,
                paliers: answer['credit_renego_paliers_' + pretID].map(
                    (palier) => {
                        return {
                            mensualite: palier.mensualite * 100,
                            duree: palier.duree,
                        }
                    }
                ),
            }
            return pret
        })
    }
    return pretARenegoier
}

/*
    Tableau les prêt en cours 
*/
const ConstructionObjetPretEnCours = (answer) => {
    var pretEnCours = []

    if (answer.credit_existants_list) {
        pretEnCours = answer.credit_existants_list.map((pretID) => {
            var pret = {
                duree: answer['credit_existants_duree_' + pretID]
                    ? answer['credit_existants_duree_' + pretID]
                    : 0,
                mensualite: answer['credit_existants_mens_' + pretID]
                    ? answer['credit_existants_mens_' + pretID] * 100
                    : 0,
                type: answer['credit_existants_type_' + pretID]
                    ? answer['credit_existants_type_' + pretID]
                    : 'CONSO',
                devenir: 'CONSERVE',
            }
            return pret
        })
    }
    return pretEnCours
}

const ConstructionObjetOrigine = (answer) => {
    var origine = {
        'cle-wai': answer.source_cle ? answer.source_cle : null,
        'cle-rattachement': answer.source_cle_rattachement
            ? answer.source_cle_rattachement
            : null,
        'entite-code': answer.source_entite_code
            ? answer.source_entite_code
            : null,
        'apporteur-code': answer.source_apporteur_code
            ? answer.source_apporteur_code
            : null,
        campagne: answer.source_campagne ? answer.source_campagne : null,
        'external-id': answer.source_ext_id ? answer.source_ext_id : null,
        creation: answer.source_origin_creation
            ? answer.source_origin_creation
            : 'TUNNEL_DEFAULT',
        'id-contact-source': answer.origine_id_contact
            ? answer.origine_id_contact
            : null,
        'id-utilisateur-cible': answer.source_id_utilisateur_cible
            ? answer.source_id_utilisateur_cible
            : null,
    }
    return origine
}

const conversionDate = (dateString) => {
    if (dateString && dateString !== '') {
        dateString = dateString.replaceAll('/', '')
        const day = dateString.substring(0, 2)
        const month = dateString.substring(2, 4)
        const year = dateString.substring(4, 8)
        return year + '-' + month + '-' + day
    }
}

/*
    Tableau des emprunteur
*/
const ConstructionObjetEmprunteur = (answer) => {
    var emprunteurs = [
        {
            id: answer.emprunteurs_id_1,
            nom: answer.contact_nom ? answer.contact_nom : '',
            prenom: answer.contact_prenom ? answer.contact_prenom : '',
            ordre: 1,
            'dossier-id': answer.emprunteurs_dossier_id_1,
            'categorie-pro': answer.emprunteurs_type_emploi_1,
            'categorie-pro-depuis': answer.emprunteurs_duree_salaire_1,
            'categorie-pro-nombre-bilan': answer.emprunteurs_emploi_bilan_1,
            'situation-habitation-actuelle': answer.emprunteurs_hab_actuelle,
            'situation-habitation-actuelle-devenir': answer.emp_hab_devenir,
            'situation-habitation-actuelle-devenir-valeur':
                answer.emp_hab_devenir_valeur
                    ? answer.emp_hab_devenir_valeur * 100
                    : 0,
            'situation-habitation-actuelle-garder-location':
                answer.situation_habitation_actuelle_garder_location === 'OUI'
                    ? true
                    : false,
            age: calculeAgeFromDateString(answer.emprunteurs_date_naissance_1),
            d_naissance: conversionDate(answer.emprunteurs_date_naissance_1),
            'primo-accedant': answer.emp_proprio_last_2_ans === 'OUI' ? 0 : 1,
            mel: answer.contact_mail,
            tel: answer.contact_mobile,
            demarchage_mec:
                answer.demarchage_mec_accord == undefined
                    ? false
                    : answer.demarchage_mec_accord,
            demarchage_part:
                answer.demarchage_part_accord == undefined
                    ? false
                    : answer.demarchage_part_accord,
            rgpd_part_accord:
                answer.rgpd_part_accord == undefined
                    ? false
                    : answer.rgpd_part_accord,
            adresse: {
                pays: answer.emprunteurs_hab_pays.value,
                cc:
                    answer.emprunteurs_hab_pays.value !== 'FRA'
                        ? constants.CP_HORS_FRANCE
                        : answer.emprunteurs_hab_actuelle_localisation.cc,
                cp:
                    answer.emprunteurs_hab_pays.value !== 'FRA'
                        ? constants.CP_HORS_FRANCE
                        : answer.emprunteurs_hab_actuelle_localisation.cp,
                ville:
                    answer.emprunteurs_hab_pays.value !== 'FRA'
                        ? constants.VILLE_HORS_FRANCE
                        : answer.emprunteurs_hab_actuelle_localisation.name,
            },
            revenus: {
                salaire: answer.emprunteurs_salaire_net_mensuel_1
                    ? ConvertionEuroCentime(
                          answer.emprunteurs_salaire_net_mensuel_1
                      )
                    : 0,
                'nombre-de-mois': answer.emprunteurs_nb_mois_salaire_1
                    ? answer.emprunteurs_nb_mois_salaire_1
                    : 12,
                prime: answer.emprunteurs_primes_1
                    ? ConvertionEuroCentime(answer.emprunteurs_primes_1)
                    : 0,
                aide: answer.emprunteurs_rev_sociaux_1
                    ? ConvertionEuroCentime(answer.emprunteurs_rev_sociaux_1)
                    : 0,
                pension: answer.emprunteurs_rev_pensions_1
                    ? ConvertionEuroCentime(answer.emprunteurs_rev_pensions_1)
                    : 0,
                foncier: answer.emprunteurs_rev_foncier_1
                    ? ConvertionEuroCentime(answer.emprunteurs_rev_foncier_1)
                    : 0,
            },
        },
    ]

    if (answer.emp_type_emprunteur === '2') {
        emprunteurs.push({
            id: answer.emprunteurs_id_2,
            ordre: 2,
            'dossier-id': answer.emprunteurs_dossier_id_2,
            'categorie-pro': answer.emprunteurs_type_emploi_2,
            'categorie-pro-depuis': answer.emprunteurs_duree_salaire_2,
            'categorie-pro-nombre-bilan': answer.emprunteurs_emploi_bilan_2,
            'situation-habitation-actuelle': answer.emprunteurs_hab_actuelle,
            'situation-habitation-actuelle-devenir': answer.emp_hab_devenir,
            'situation-habitation-actuelle-devenir-valeur':
                answer.emp_hab_devenir_valeur
                    ? answer.emp_hab_devenir_valeur * 100
                    : 0,
            'situation-habitation-actuelle-garder-location':
                answer.situation_habitation_actuelle_garder_location === 'OUI'
                    ? true
                    : false,
            age: calculeAgeFromDateString(answer.emprunteurs_date_naissance_2),
            d_naissance: conversionDate(answer.emprunteurs_date_naissance_2),
            'primo-accedant': answer.emp_proprio_last_2_ans === 'OUI' ? 0 : 1,
            adresse: {
                pays: answer.emprunteurs_hab_pays.value,
                cc:
                    answer.emprunteurs_hab_pays.value !== 'FRA'
                        ? constants.CP_HORS_FRANCE
                        : answer.emprunteurs_hab_actuelle_localisation.cc,
                cp:
                    answer.emprunteurs_hab_pays.value !== 'FRA'
                        ? constants.CP_HORS_FRANCE
                        : answer.emprunteurs_hab_actuelle_localisation.cp,
                ville:
                    answer.emprunteurs_hab_pays.value !== 'FRA'
                        ? constants.VILLE_HORS_FRANCE
                        : answer.emprunteurs_hab_actuelle_localisation.name,
            },
            revenus: {
                salaire: answer.emprunteurs_salaire_net_mensuel_2
                    ? ConvertionEuroCentime(
                          answer.emprunteurs_salaire_net_mensuel_2
                      )
                    : 0,
                'nombre-de-mois': answer.emprunteurs_nb_mois_salaire_2
                    ? answer.emprunteurs_nb_mois_salaire_2
                    : 12,
                prime: answer.emprunteurs_primes_2
                    ? ConvertionEuroCentime(answer.emprunteurs_primes_2)
                    : 0,
                aide: answer.emprunteurs_rev_sociaux_2
                    ? ConvertionEuroCentime(answer.emprunteurs_rev_sociaux_2)
                    : 0,
                pension: answer.emprunteurs_rev_pensions_2
                    ? ConvertionEuroCentime(answer.emprunteurs_rev_pensions_2)
                    : 0,
                foncier: answer.emprunteurs_rev_foncier_2
                    ? ConvertionEuroCentime(answer.emprunteurs_rev_foncier_2)
                    : 0,
            },
        })
    }
    return emprunteurs
}

const PreparationObject = (answer) => {
    var dossier = {
        etat: 'PROJET_A_QUALIFIER',
        'banques-contactees': ConstructionObjetOrganismeSolicite(answer),
        'revenus-fiscaux-n1': answer.finance_revenu_fiscal_ref
            ? ConvertionEuroCentime(answer.finance_revenu_fiscal_ref)
            : 0,
        apporteur: null, // Todo quand ID apporteur fourni !
    }
    dossier.origine = ConstructionObjetOrigine(answer)
    dossier.campagne_utm = store.getState().answer.source_campagne_utm

    var nbPersonneFoyer = 1
    if (answer.emp_nb_personnes_foyer && answer.emp_nb_personnes_foyer !== 0) {
        nbPersonneFoyer = answer.emp_nb_personnes_foyer
    }
    dossier['informations-emprunteur'] = {
        nombre:
            answer.emp_type_emprunteur === 'SCI'
                ? 0
                : answer.emp_type_emprunteur,
        'nombre-personne-foyer': nbPersonneFoyer,
        'accord-contact': answer.rgpd_accord,
        sci: answer.emp_type_emprunteur === 'SCI' ? true : false,
    }

    dossier.emprunteurs = ConstructionObjetEmprunteur(answer)

    dossier.charges = {
        loyer: answer.situation_habitation_actuelle_location_loyer
            ? ConvertionEuroCentime(
                  answer.situation_habitation_actuelle_location_loyer
              )
            : 0,
        'pensions-alimentaires': answer.pension_out
            ? ConvertionEuroCentime(answer.pension_out)
            : 0,
    }

    dossier.financement = {
        apport: answer.finance_apport
            ? ConvertionEuroCentime(answer.finance_apport)
            : 0,
        'epargne-apres-apport': answer.finance_epargne_apres_apport
            ? ConvertionEuroCentime(answer.finance_epargne_apres_apport)
            : 0,
        'apport-couvert': 0,
        'duree-pret-principal': answer.finance_duree_souhaite,
        'mensualite-totale': 0,
    }

    dossier['credits-existants'] = ConstructionObjetPretEnCours(answer)
    dossier.code_promo = answer.code_promo
    return dossier
}

/*
    construit le JSON a envoyer au serveur pour réaliser un dépot de dossier "trouver".
*/
const ConstructionJsonEnrDossierTrouve = (answer) => {
    var dossier = PreparationObject(answer)

    switch (answer.prj_type) {
        case 'LOGEMENT_NEUF':
            dossier['projet-neuf'] = {
                maturite: answer.prj_maturite,
                type: answer.prj_type,
                type_log: answer.prj_type_log,
                usage: answer.prj_usage,
                'achat-ttc': ConvertionEuroCentime(answer.prj_montant_achat),
                'frais-negociation': answer.prj_montant_frais_agence
                    ? ConvertionEuroCentime(answer.prj_montant_frais_agence)
                    : 0,
                'frais-notaire': answer.prj_montant_frais_notaire
                    ? ConvertionEuroCentime(answer.prj_montant_frais_notaire)
                    : 0,
                'frais-notaire-fixes':
                    answer.prj_montant_frais_notaire != undefined &&
                    answer.prj_montant_frais_notaire != null
                        ? 1
                        : 0,
                'futur-loyer-estime': answer.prj_futur_loyer_estim
                    ? ConvertionEuroCentime(answer.prj_futur_loyer_estim)
                    : 0,
                'dispositif-fiscal':
                    answer.prj_dispositif_fiscal &&
                    answer.prj_dispositif_fiscal !== ''
                        ? answer.prj_dispositif_fiscal
                        : 'NULL',
                'taux-tva': 0,
                'eligibilite-ptz':
                    answer.emp_proprio_last_2_ans === 'OUI' ? 0 : 1,
                cc: answer.prj_localisation_ville.cc
                    ? answer.prj_localisation_ville.cc
                    : '00000',
                cp: answer.prj_localisation_ville.cp
                    ? answer.prj_localisation_ville.cp
                    : '00000',
            }
            break
        case 'LOGEMENT_ANCIEN':
            dossier['projet-ancien'] = {
                maturite: answer.prj_maturite,
                type: answer.prj_type,
                usage: answer.prj_usage,
                'net-vendeur': answer.prj_montant_achat
                    ? ConvertionEuroCentime(answer.prj_montant_achat)
                    : 0,
                'frais-negociation': answer.prj_montant_frais_agence
                    ? ConvertionEuroCentime(answer.prj_montant_frais_agence)
                    : 0,
                travaux: answer.prj_montant_travaux
                    ? ConvertionEuroCentime(answer.prj_montant_travaux)
                    : 0,
                'frais-autre': answer.prj_montant_frais_divers
                    ? ConvertionEuroCentime(answer.prj_montant_frais_divers)
                    : 0,
                'frais-notaire': answer.prj_montant_frais_notaire
                    ? ConvertionEuroCentime(answer.prj_montant_frais_notaire)
                    : 0,
                'frais-notaire-fixes':
                    answer.prj_montant_frais_notaire != undefined &&
                    answer.prj_montant_frais_notaire != null
                        ? 1
                        : 0,
                'futur-loyer-estime': answer.prj_futur_loyer_estim
                    ? ConvertionEuroCentime(answer.prj_futur_loyer_estim)
                    : 0,
                'eligibilite-ptz':
                    answer.emp_proprio_last_2_ans === 'OUI' ? 0 : 1,
                cc: answer.prj_localisation_ville.cc
                    ? answer.prj_localisation_ville.cc
                    : '00000',
                cp: answer.prj_localisation_ville.cp
                    ? answer.prj_localisation_ville.cp
                    : '00000',
            }
            break
        case 'TERRAIN_ET_CONSTRUCTION':
            dossier['projet-terrain-construction'] = {
                maturite: answer.prj_maturite,
                type: answer.prj_type,
                usage: answer.prj_usage,
                'net-vendeur': answer.prj_montant_terrain
                    ? ConvertionEuroCentime(answer.prj_montant_terrain)
                    : 0,
                construction: answer.prj_montant_construction
                    ? ConvertionEuroCentime(answer.prj_montant_construction)
                    : 0,
                'frais-viabilisation': 0,
                'eligibilite-ptz':
                    answer.emp_proprio_last_2_ans === 'OUI' ? 0 : 1,
                'frais-negociation': answer.prj_montant_frais_agence
                    ? ConvertionEuroCentime(answer.prj_montant_frais_agence)
                    : 0,
                'frais-autre': answer.prj_montant_frais_divers
                    ? ConvertionEuroCentime(answer.prj_montant_frais_divers)
                    : 0,
                'frais-notaire': answer.prj_montant_frais_notaire
                    ? ConvertionEuroCentime(answer.prj_montant_frais_notaire)
                    : 0,
                'frais-notaire-fixes':
                    answer.prj_montant_frais_notaire != undefined &&
                    answer.prj_montant_frais_notaire != null
                        ? 1
                        : 0,
                'futur-loyer-estime': answer.prj_futur_loyer_estim
                    ? ConvertionEuroCentime(answer.prj_futur_loyer_estim)
                    : 0,
                cc: answer.prj_localisation_ville.cc
                    ? answer.prj_localisation_ville.cc
                    : '00000',
                cp: answer.prj_localisation_ville.cp
                    ? answer.prj_localisation_ville.cp
                    : '00000',
            }
            break
        case 'TRAVAUX':
            dossier['projet-travaux'] = {
                maturite: answer.prj_maturite,
                type: answer.prj_type,
                usage: answer.prj_usage,
                'eligibilite-ptz':
                    answer.emp_proprio_last_2_ans === 'OUI' ? 0 : 1,
                travaux: answer.prj_montant_travaux
                    ? ConvertionEuroCentime(answer.prj_montant_travaux)
                    : 0,
                'futur-loyer-estime': answer.prj_futur_loyer_estim
                    ? ConvertionEuroCentime(answer.prj_futur_loyer_estim)
                    : 0,
                cc: answer.prj_localisation_ville.cc
                    ? answer.prj_localisation_ville.cc
                    : '00000',
                cp: answer.prj_localisation_ville.cp
                    ? answer.prj_localisation_ville.cp
                    : '00000',
            }
            break
        case 'RENEGOCIATION':
            dossier['projet-renegociation'] = {
                maturite: answer.prj_maturite,
                type: answer.prj_type,
                usage: answer.prj_usage,
                cc: answer.prj_localisation_ville.cc
                    ? answer.prj_localisation_ville.cc
                    : '00000',
                cp: answer.prj_localisation_ville.cp
                    ? answer.prj_localisation_ville.cp
                    : '00000',
                'pret-renego': ConstructionObjetPretARenegocier(answer),
            }
            break
        case 'ACHAT_SCPI':
            dossier['projet-scpi'] = {
                maturite: answer.prj_maturite,
                type: answer.prj_type,
                'eligibilite-ptz':
                    answer.emp_proprio_last_2_ans === 'OUI' ? 0 : 1,
                'achat-scpi': answer.prj_montant_achat
                    ? ConvertionEuroCentime(answer.prj_montant_achat)
                    : 0,
                'futur-loyer-estime': answer.prj_futur_loyer_estim
                    ? ConvertionEuroCentime(answer.prj_futur_loyer_estim)
                    : 0,
                'dispositif-fiscal':
                    answer.prj_dispositif_fiscal &&
                    answer.prj_dispositif_fiscal !== ''
                        ? answer.prj_dispositif_fiscal
                        : 'NULL',
                'nom-intermediaire': answer.prj_nom_intermediaire_scpi
                    ? answer.prj_nom_intermediaire_scpi
                    : 'NC',
                cp: answer.emprunteurs_hab_actuelle_localisation.cp
                    ? answer.emprunteurs_hab_actuelle_localisation.cp
                    : '00000',
            }
            break
        default:
            break
    }

    return dossier
}

/*
    construit le JSON a envoyer au serveur pour réaliser un dépot de dossier "en recherche".
*/
const ConstructionJsonEnrDossierRecherche = (answer) => {
    // prépare l'apport sur page resultat
    var dossier = PreparationObject(answer)

    dossier['projet-recherche'] = {
        type: answer.prj_type,
        usage: answer.prj_usage,
        departement: answer.prj_localisation_dep.value
            ? answer.prj_localisation_dep.value
            : '00',
        zone: answer.prj_localisation_ville
            ? answer.prj_localisation_ville.ptz.replace(' ', '_')
            : undefined,
    }

    return dossier
}

const ConstructionTunnelTemp = (answer) => {
    var obj = {}
    obj.origine = ConstructionObjetOrigine(answer)
    obj.emprunteur = ConstructionObjetEmprunteur(answer)[0]
    obj.demarchage_mec =
        answer.demarchage_mec_accord == undefined ? false : true
    obj.demarchage_part =
        answer.demarchage_part_accord == undefined ? false : true
    return obj
}

/*
    construit le JSON a envoyer au serveur pour réaliser une comparaison d'offre.
*/
const ConstructionJsonComparerOffre = (answer) => {
    var listUUID = []
    answer.files.forEach((file) => {
        if (file.uuid !== '') {
            listUUID.push(file.uuid)
        }
    })

    var ComparerOffre = {
        nom: answer.contact_nom ? answer.contact_nom : '',
        prenom: answer.contact_prenom ? answer.contact_prenom : '',
        mel: answer.contact_mail ? answer.contact_mail : '',
        tel: answer.contact_mobile ? answer.contact_mobile : '',
        'nombre-emprunteurs': answer.type_emprunteur
            ? answer.emp_nb_personnes_foyer
            : 1,
        'projet-type': answer.prj_type ? answer.prj_type : 'LOGEMENT_ANCIEN',
        'projet-usage': answer.prj_usage ? answer.prj_usage : '',
        montant: answer.prj_montant_achat
            ? ConvertionEuroCentime(answer.prj_montant_achat)
            : 0,
        apport: answer.finance_apport
            ? ConvertionEuroCentime(answer.finance_apport)
            : 0,
        'doc-uuids': listUUID,
        origine: ConstructionObjetOrigine(answer),
    }
    return ComparerOffre
}

const AnonymiserDossierToString = (dossier) => {
    var dossierAno = dossier
    /*
    dossierAno.emprunteurs[0].mel = "mel@mel.fr";
    dossierAno.emprunteurs[0].tel = "0606060606";
    dossierAno.emprunteurs[0].nom = "nom";
    dossierAno.emprunteurs[0].prenom = "prenom";
    if(dossierAno.emprunteurs[1]){
        dossierAno.emprunteurs[1].mel= "mel@mel.fr";
        dossierAno.emprunteurs[1].tel= "0606060606";
    }*/
    return JSON.stringify(dossierAno)
}

export {
    CalculFraisDeNotaire,
    UpdateIntField,
    relanceCodeSms,
    InitDossier,
    TestRegexForField,
    InitHistoryListener,
    EnregistrerDossier,
    PaliersObjectToCapitalDuree,
    ConstructionJsonComparerOffre,
    CalculNbDocumentPretPourComparerOffre,
    CalculPoidTotalDocPourComparerOffre,
    ActualisationResultatMaxEmpruntable,
    IntToSpacedDelimitedString,
    AnonymiserDossierToString,
    sauterChampsPreremplis,
    calculeAgeFromDateString,
}
